import React, {useState} from 'react';
import PropTypes from 'prop-types';

import {currentResource} from '../../../util/utils';

import columns from './columns';

import Search from '../../CoreWrappers/Search';
import CustomTable from '../../CoreWrappers/CustomTable';
import StyledEngagementsTableSearch from './StyledEngagementsTableSearch';
import StyledEngagementsTable from './StyledEngagementsTable';
import {GARoleTypeId} from '../../../util/uiconstants';

const EngagementsTable = ({
	items = null,
	selected = null,
	onSelect = null,
	maxSelect = null,
	errorMessage = null,
	labels
}) => {
	const [searchString, setSearchString] = useState('');

	if (!items) return false;

	const handleFilterEngagements = ({id, description, clientName}) => {
		const idMatches = !!`${id}`.includes(searchString);
		const descriptionMatches = !!description.toLowerCase().includes(searchString.toLowerCase());
		const clientNameMatches = !!clientName.toLowerCase().includes(searchString.toLowerCase());
		return idMatches || descriptionMatches || clientNameMatches;
	};

	let filteredItems = [...items];
	if (!!searchString) filteredItems = items.filter(handleFilterEngagements);

	const renderSearch = () => {
		const props = {
			onChange: (value) => {
				setSearchString(value);
			},
			placeholder: labels.searchPlaceholder,
			value: searchString,
			onClear: () => {
				setSearchString('');
			}
		};

		return (
			<StyledEngagementsTableSearch>
				<Search {...props} />
			</StyledEngagementsTableSearch>
		);
	};

	const props = {
		id: 'engagementsTable',
		data: filteredItems,
		columns: columns(currentResource.engagementTableLabels),
		labels: {
			emptyMessage: !!searchString && items.length > 0 ? labels.noDataToDisplay : labels.noAccessToEng
		}
	};

	if (onSelect) {
		props.selected = selected;
		props.onSelect = (items) => onSelect([...items]);
		props.maxSelect = maxSelect;
	}

	if (errorMessage) props.errorMessage = errorMessage;

	return (
		<StyledEngagementsTable>
			{renderSearch()}
			<CustomTable {...props} />
		</StyledEngagementsTable>
	);
};

EngagementsTable.propTypes = {
	items: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.number.isRequired,
			description: PropTypes.string.isRequired,
			clientName: PropTypes.string.isRequired,
			roleType: PropTypes.oneOf([GARoleTypeId.Primary, GARoleTypeId.Region, GARoleTypeId.Component])
		})
	),
	selected: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
	onSelect: PropTypes.func,
	maxSelect: PropTypes.number,
	errorMessage: PropTypes.string
};

export default EngagementsTable;
